"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../../../../helpers");
var _GridView = require("../GridView");
var _ShareButton = _interopRequireDefault(require("../ShareButton"));
var _Product = require("../../Product");
var _style = _interopRequireDefault(require("./style.css"));
var _FavoriteButton = _interopRequireDefault(require("../FavoriteButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// A resrouce item when rendered in LIST mode
var ListView = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function ListView() {
    _classCallCheck(this, ListView);
    return _callSuper(this, ListView, arguments);
  }
  _inherits(ListView, _React$Component);
  return _createClass(ListView, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        getShareUrl = _this$props.getShareUrl,
        currentTab = _this$props.currentTab,
        useFavorite = _this$props.useFavorite;
      return /*#__PURE__*/_react["default"].createElement("div", null, this.props.data.map(function (resource) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: 'row ' + _style["default"].item,
          style: {
            borderLeft: resource.borderColor && "10px solid ".concat((0, _helpers.getBorderColor)(resource.borderColor))
          },
          key: resource.id
        }, displayOptions.showThumbnail && /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-2"
        }, (0, _GridView.renderThumbnail)(resource)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-".concat(displayOptions.showThumbnail ? '10' : '12')
        }, (0, _GridView.renderTitle)(resource, displayOptions), (0, _GridView.renderDescription)(resource, displayOptions), resource.type === 'product' ? /*#__PURE__*/_react["default"].createElement(_Product.ProductFooter, {
          resource: resource,
          useFavorite: useFavorite,
          displayOptions: displayOptions,
          externalShareUrl: getShareUrl(currentTab, resource)
        }) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-6"
        }, displayOptions.showTags && /*#__PURE__*/_react["default"].createElement("p", {
          className: _style["default"].tags
        }, resource.tags && Object.keys(resource.tags).map(function (tag, j) {
          if (Object.keys(resource.tags).length === j + 1) {
            return resource.tags[tag];
          }
          return resource.tags[tag] + ', ';
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-3"
        }, (0, _GridView.renderIcons)(resource, displayOptions)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-3 d-flex align-items-end justify-content-end"
        }, displayOptions.showFavoriteIcon && /*#__PURE__*/_react["default"].createElement(_FavoriteButton["default"], {
          resource: resource,
          useFavorite: useFavorite,
          color: displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.favoriteButtonColor
        }), displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
          name: resource.published_label,
          url: _this.props.getShareUrl(_this.props.currentTab, resource),
          displayOptions: displayOptions
        })))));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ListView, "propTypes", {
  currentTab: _propTypes["default"].string,
  data: _propTypes["default"].array.isRequired,
  getShareUrl: _propTypes["default"].func,
  displayOptions: _propTypes["default"].object,
  useFavorite: _propTypes["default"].func
});